/**
 *
 */
export default class Terceros {
  name = '';
}
